import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import imgArrow from 'src/assets/images/arrow-right.svg';

const NextLine = props => (
  <Root {...props}>
    <Link to={props.link}>
      {props.text} <img src={imgArrow} alt="right-arrow" />
    </Link>
  </Root>
);

export default NextLine;

NextLine.propTypes = {
  text: PropTypes.string,
};

const Root = styled.div`
  width: 100%;
  height: 18px;
  background-color: ${({ theme }) => theme.colorPrimary};
  display: flex;
  justify-content: center;
  position: relative;
  a {
    position: absolute;
    top: -9px;
    color: black;
    background-color: white;
    font-family: ${({ theme }) => theme.fontHeader};
    font-size: 14px;
    text-transform: uppercase;
    padding: 10px 20px;
    border-radius: 30px;
    box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    transition: 0.5s ease;
    &:hover {
      background-color: ${({ theme }) => theme.colorPrimary};
    }
    img {
      margin-left: 20px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/NextLine.js